import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import CommunityRecommend from "../../home/CommunityRecommend";

import CommunityEachBoardType from "./CommunityEachBoardType";
import CommunityEachListType from "./CommunityEachListType";

const CommunityEachComponent = ({
	communityList,
	handleCommunity,
	handleCommentMove,
	ingreList,
}) => {
	const [showType, setShowType] = useState("board");
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);

	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	if (reduxChannel?.user_id === 1 || reduxChannel?.user_id === 9)
		return (
			<div className={`community-each-component-list`}>
				{/*<div className={`community-type-div`}>*/}
				{/*    <Button*/}
				{/*        className={`${showType === "board" ? "clicked" : ""}`}*/}
				{/*        onClick={() => setShowType("board")}*/}
				{/*    >*/}
				{/*        게시판형*/}
				{/*    </Button>*/}
				{/*    <Button*/}
				{/*        className={`${showType === "list" ? "clicked" : ""}`}*/}
				{/*        onClick={() => setShowType("list")}*/}
				{/*    >*/}
				{/*        리스트형*/}
				{/*    </Button>*/}
				{/*</div>*/}
				{communityList?.map((item, idx) => (
					<>
						<div
							className={`community-each-component`}
							key={`community-each-component-${idx}`}
							onClick={() => handleCommunity(item)}
						>
							{showType === "board" ? (
								<CommunityEachBoardType
									item={item}
									handleCommentMove={handleCommentMove}
								/>
							) : (
								<CommunityEachListType item={item} />
							)}
						</div>

						{mediaResult && (
							<>
								{idx === 0 && (
									<CommunityRecommend
										type={"ingredient"}
										categoryList={ingreList}
									/>
								)}
							</>
						)}
					</>
				))}
			</div>
		);
	else
		return (
			<div className={`community-each-component-list`}>
				{/*<div className={`community-type-div`}>*/}
				{/*    <Button*/}
				{/*        className={`${showType === "board" ? "clicked" : ""}`}*/}
				{/*        onClick={() => setShowType("board")}*/}
				{/*    >*/}
				{/*        게시판형*/}
				{/*    </Button>*/}
				{/*    <Button*/}
				{/*        className={`${showType === "list" ? "clicked" : ""}`}*/}
				{/*        onClick={() => setShowType("list")}*/}
				{/*    >*/}
				{/*        리스트형*/}
				{/*    </Button>*/}
				{/*</div>*/}
				{communityList?.map((item, idx) => (
					<>
						<div
							className={`community-each-component`}
							key={`community-each-component-${idx}`}
							onClick={() => handleCommunity(item)}
						>
							<CommunityEachListType item={item} />
						</div>
					</>
				))}
			</div>
		);
};
export default CommunityEachComponent;
